import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Fri Oct 19 2018
 * @author PKr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { ThemeConverter, ThemesViewDTOConverter, jsonConversions } from '@logio/common-be-fe';
import { CRUTransportLayer } from '../CRUTransportLayer';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var ThemeLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(ThemeLayer, _CRUTransportLayer);

  function ThemeLayer() {
    var _this;

    _classCallCheck(this, ThemeLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThemeLayer).call(this, CONSTANTS.API.ENDPOINTS.THEMES));
    /**
     * Gets list of ThemesViewDTO
     */

    _this.getAllViews = function () {
      return api(_this.baseUri).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getViewConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Filter Themes by filter params
     * @param filter
     */


    _this.filter = function (filter) {
      return api("".concat(_this.baseUri, "/filter")).post(filter, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getViewConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Deletes one particular item based on Theme id
     * @param id
     */


    _this.delete = function (id) {
      return api("".concat(_this.baseUri, "/").concat(id)).delete().then(function () {
        return Promise.resolve();
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };

    return _this;
  }

  _createClass(ThemeLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "getViewConverter",
    value: function getViewConverter() {
      return this.viewConverter;
    }
  }]);

  return ThemeLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", ThemeConverter)], ThemeLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", ThemesViewDTOConverter)], ThemeLayer.prototype, "viewConverter", void 0);